import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=0fc8eae6&scoped=true"
import script from "./AddressInfo.vue?vue&type=script&lang=js"
export * from "./AddressInfo.vue?vue&type=script&lang=js"
import style0 from "./AddressInfo.vue?vue&type=style&index=0&id=0fc8eae6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8eae6",
  null
  
)

export default component.exports